import React, { useState, useContext } from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { forgotPassword } = useContext(AuthContext);
  const history = useHistory();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await forgotPassword(email);
      history.push({ pathname: '/reset-password', state: { email } });
    } catch (err) {
      setError('Failed to send the reset code. Please try again.');
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2 className="auth-title">Forgot Password</h2>
        <p>Enter your email and we'll send you a 6-digit reset code.</p>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group id="email" style={{ display: 'flex', flexDirection: 'column' }}>
            <Form.Label>Email</Form.Label>
            <Form.Control className="auth-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </Form.Group>
          <Button className="auth-btn auth-btn-primary" type="submit" disabled={loading}>
            Send Reset Code
          </Button>
        </Form>
        <a className="auth-link" href="/reset-password">Already have a code?</a>
        <a className="auth-link" href="/">Back to login</a>
      </div>
    </div>
  );
}
